<template>
  <div class="giftcode-exchange">
    <v-form ref="form" v-model="valid" lazy-validation class="login__form">
      <div class="user d-none">
        <v-text-field
          v-if="isAuthenticated"
          v-model="username"
          :rules="nameRules"
          label="Tên tài khoản"
          outlined
          disabled
          required
          height="40px"
          dense
          class="login__input"
        ></v-text-field>
        <v-text-field
          v-else
          v-model="name"
          :rules="nameRules"
          label="Tên tài khoản"
          outlined
          required
          height="40px"
          dense
          class="login__input"
        ></v-text-field>
      </div>

      <div class="gametitle">
        <v-select
          v-if="!this.$route.params.id"
          ref="gameName"
          v-model="selected"
          :items="gameTitle"
          :rules="gameRules"
          label="Danh sách game"
          outlined
          required
          height="40px"
          dense
          class="login__input"
          @change="gameSelect(selected)"
        ></v-select>
      </div>

      <v-select
        v-model="group_server"
        ref="group_server"
        :items="group_name"
        item-text="name"
        :rules="groupRules"
        v-if="can_use_code === true"
        label="Chọn cụm server"
        outlined
        required
        height="40px"
        dense
        class="login__input"
        @change="groupServerSelect(group_server)"
      ></v-select>

      <v-select
        v-model="server"
        ref="server"
        :items="servers"
        item-text="name"
        :rules="serverRules"
        v-if="can_use_code === true"
        label="Chọn máy chủ"
        outlined
        required
        height="40px"
        dense
        class="login__input"
        @change="serverSelect(server)"
      ></v-select>

      <v-select
        v-model="character"
        ref="character"
        :items="characters"
        item-text="name"
        :rules="characterRules"
        v-if="can_use_code === true"
        label="Danh sách nhân vật"
        outlined
        required
        height="40px"
        dense
        class="login__input"
        @change="characterSelect(character)"
      ></v-select>

      <div class="codegame" v-if="can_use_code === true">
        <div
          v-if="this.code_game !== '' && this.$route.params.id"
          class="code-game"
          style="position: relative"
        >
          <v-text-field
            v-model="code_game"
            ref="codeId"
            :rules="codeRules"
            label="Nhập Giftcode"
            outlined
            required
            height="40px"
            dense
            class="login__input"
            disabled
          >
          </v-text-field>
          <v-btn class="copy-btn pa-0" depressed text>
            <v-icon v-clipboard:copy="code_game">mdi-content-copy</v-icon>
          </v-btn>
        </div>
        <div v-else style="position: relative" class="code">
          <v-text-field
            ref="code"
            v-model="code"
            :rules="codeRules"
            label="Nhập Giftcode"
            outlined
            required
            height="40px"
            dense
            class="login__input"
          ></v-text-field>
          <!-- <v-btn class="copy-btn pa-0" depressed text>
            <v-icon v-clipboard:copy="code">mdi-content-copy</v-icon>
          </v-btn> -->
        </div>
      </div>

      <div class="recaptcha">
        <div class="d-flex justify-center">
          <vue-recaptcha
            :v-model="rcaptcha"
            :sitekey="sitekey"
            :loadRecaptchaScript="true"
            @verify="verifyMethod"
          ></vue-recaptcha>
        </div>
        <span class="recaptcha__alert" v-if="recaptchaAlert"
          >Vui lòng xác nhận không phải là robot</span
        >
      </div>
      <v-btn
        :disabled="!valid"
        v-if="can_use_code === true"
        color="#ccc"
        class="login__btn login__btn--id text-none mt-0"
        outlined
        @click="validate"
      >
        Tiếp tục
      </v-btn>
      <div class="giftcode-exchange__desc">
        <div v-if="can_use_code === true">
          <p>
            1. Quà sẽ được gửi vào thư trong game khi nhập Giftcode thành công.
          </p>
          <p>
            2. Lưu ý các nguyên nhân có thể dẫn tới việc nhập Giftcode không
            thành công như: Nhập thiếu ký tự, nhầm 2 ký tự gần giống nhau, hết
            hạn Giftcode...
          </p>
          <p>
            3. Các game không hỗ trợ đổi code sẽ không xuất hiện khi chọn game.
            Vui lòng đổi trong game!
          </p>
        </div>
        <div v-else>
          <p>
            Game này hiện tại chưa hỗ trợ đổi code trên trang giftcode. Vui lòng
            đổi trong game hoặc thử lại sau!
          </p>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script
  src="https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit"
  async
  defer
></script>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { mapGetters, mapState } from 'vuex'
import { ExchangeCodes, Validate, Logic } from '../services/functions'

export default {
  name: 'ExchangeCode',
  components: { VueRecaptcha },
  data: () => ({
    recaptchaAlert: false,
    sitekey: '6Lfi0CUdAAAAAAePyUHkPIvdUXhCp3ZVHzCgpgGy',
    rcaptcha: '',
    can_use_code: [],
    select: { name: '' },
    game_id: '',
    code: '',
    selected: [],
    server: [],
    group_server: [],
    character: {},
    valid: true,
    name: '',
    nameRules: [v => !!v || 'Tên đăng nhập là bắt buộc'],
    gameRules: [
      v => !!v || 'Vui lòng chọn game',
      v => (v && v.length !== 0) || 'Vui lòng chọn game',
    ],
    groupRules: [
      v => !!v || 'Vui lòng chọn cụm server',
      v => (v && v.length !== 0) || 'Vui lòng chọn cụm server',
    ],
    serverRules: [
      v => !!v || 'Vui lòng chọn server',
      v => (v && v.length !== 0) || 'Vui lòng chọn server',
    ],
    characterRules: [
      v => !!v || 'Vui lòng chọn nhân vật',
      v => typeof v !== 'object' || 'Vui lòng chọn nhân vật',
    ],
    codeRules: [v => !!v || 'Mã Giftcode là bắt buộc'],
  }),

  computed: {
    ...mapGetters([
      'GAMES',
      'isAuthenticated',
      'GAME_NAME',
      'SERVERS',
      'GROUP_NAME',
      'GROUPS',
      'CHARACTERS',
      'GIFTCODES',
      'GIFTCODE_SEND',
      'GIFTCODE_ADD',
      'GAME_BY_ID',
    ]),
    ...mapState({
      username: state =>
        state.auth.username === '' ? state.user.username : state.auth.username,
      loginRequired: state => state.status.login_required,
    }),
    games() {
      return this.$store.getters.GAMES
    },
    code_game() {
      return this.$store.state.code
    },
    gameById() {
      return this.$store.getters.GAME_BY_ID
    },
    gameName() {
      return this.$store.getters.GAME_NAME
    },
    servers() {
      return this.$store.getters.SERVERS
    },
    group_name() {
      return this.$store.getters.GROUP_NAME
    },
    groups() {
      return this.$store.getters.GROUPS
    },
    giftcode_send() {
      return this.$store.getters.GIFTCODE_SEND
    },
    giftcode_add() {
      return this.$store.getters.GIFTCODE_ADD
    },
    characters() {
      return this.$store.getters.CHARACTERS
    },
    gameTitle() {
      return this.gameName
    },
    gameNameItems() {
      return [`${this.$store.state.game_name_item}`]
    },
  },

  created() {
    this.code = this.code_game
  },

  watch: {
    group_server(item) {
      window.localStorage.setItem('server_group', item)
    },
    server(item) {
      window.localStorage.getItem('server_name', item)
    },
    character(item) {
      window.localStorage.setItem('character_name', item)
    },
  },

  mounted() {
    if (this.loginRequired === false) {
      if (
        window.localStorage.getItem('game_id') &&
        window.localStorage.getItem('can_use_code') === 'true'
      ) {
        this.$store.dispatch('SERVER_REQUEST', {
          game_id: window.localStorage.getItem('game_id'),
        })
      }
    }

    this.can_use_code = JSON.parse(localStorage.getItem('can_use_code')) || []

    if (window.localStorage.getItem('save')) {
      const vgpId = window.localStorage.getItem('userId')
      const saveUser = JSON.parse(window.localStorage.getItem('save'))
      const gameId = window.localStorage.getItem('game_id')
      // lấy ra user hiện tại đang login
      const getUser = saveUser.filter(item => item.id === vgpId)
      // Check nếu có data
      if (getUser[0] !== undefined) {
        const data = getUser[0].data
        if (data) {
          data.forEach(element => {
            if (gameId === element.game_id) {
              window.localStorage.setItem(
                'character_name',
                element.character_name
              )
              window.localStorage.setItem('server_name', element.server_name)
              this.$store.dispatch('SERVER_REQUEST', {
                game_id: element.game_id,
              })
              this.$store.dispatch('CHARACTER_REQUEST', {
                game_id: element.game_id,
                user_id: element.user_id,
                server_id: element.server_id,
              })
              // this.game_id_test(element)
              const list = JSON.parse(
                window.localStorage.getItem('server_by_group')
              )
              if (JSON.stringify(element.list) === JSON.stringify(list)) {
                this.$store.commit('SERVER_REQUEST', list)
              } else {
                this.$store.commit('SERVER_REQUEST', element.list)
                window.localStorage.setItem('server_name', element.server_name)
              }

              this.selected = element.game_server
              this.group_server = element.server_group
              this.server = element.server_name
              this.character = element.character_name

              if (this.server === element.server_name) {
                window.localStorage.setItem('server_name', element.server_name)
              }
            }
          })
        }
      }
    } else {
      this.group_server = []
      this.server = []
      this.character = {}
    }
  },
  updated() {
    if (this.loginRequired === false) {
      if (this.giftcode_send.type === 'unique') {
        this.$store.commit('updateCode', this.giftcode_send.unique_giftcode)
      }

      if (this.gameById) {
        this.$store.commit('gameNameItem', this.gameById.name)
      }
    }
  },

  methods: {
    validate: Validate.validate,
    gameSelect: ExchangeCodes.gameSelect,
    serverSelect: ExchangeCodes.serverSelect,
    characterSelect: ExchangeCodes.characterSelect,
    groupServerSelect: ExchangeCodes.groupServerSelect,
    // Method saveUser
    test_server_name: Logic.test_server_name,
    test_server_group: Logic.test_server_group,
    test_same_game_id: Logic.test_same_game_id,
    test_game_id: Logic.test_game_id,
    test_data: Logic.test_data,
    test_user_id: Logic.test_user_id,
    test_character_name: Logic.test_character_name,
    test_save_user: Logic.test_save_user,
    action_giftcode_add: Logic.action_giftcode_add,
    action_giftcode_add_value: Logic.action_giftcode_add_value,
    action_giftcode_add_server: Logic.action_giftcode_add_server,
    action_save_user: Logic.action_save_user,
    openRcaptcha() {
      this.dialogRcaptcha = true
    },
    verifyMethod(response) {
      if (response) {
        this.rcaptcha = response
      } else {
        this.rcaptcha = ''
      }
    },
  },
}
</script>

<style lang="scss">
.code,
.code-game {
  position: relative;
  button {
    position: absolute;
    top: 0;
    right: 0;
  }
}
.copy-btn {
  position: absolute;
  top: 0;
  right: 0;
  height: 40px !important;
  background: none !important;
  span.v-ripple_container {
    opacity: 0 !important;
  }
  &:hover {
    &:before {
      opacity: 0 !important;
    }
  }
}
</style>
